/* ETHYLGO — « 2 achetés, le 3e offert », composé avec les coloris du produit.

   Pourquoi un asset propre plutôt que quietude-set-offer.js : celui-ci parle de
   bracelets et de collections dans un dictionnaire codé en dur, et navigue sur
   trois paliers pour quarante références. Ici : un produit, trois coloris.

   Les classes `so-*` sont gardées : quietude-set-offer.css reste la source de
   l'apparence de la carte. Seules les pastilles ont leur feuille à part.

   Ce fichier n'AFFICHE que l'offre ; la déduction vient de la remise automatique.
   Il s'insère devant le formulaire de quietude-pdp.js : listener sur document en
   capture, donc avant le sien, et il ne l'intercepte que si le lot est complet.
   Sans JS, rien ne s'affiche et l'achat normal reste intact. */
(function () {
  if (window.__ethSetOffer) return;
  window.__ethSetOffer = true;

  var NBSP  = String.fromCharCode(160);
  var MINUS = String.fromCharCode(8722);
  var money = function (c) { return (c / 100).toFixed(2).replace('.', ',') + NBSP + '€'; };
  var esc = function (s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  };

  var ICO = {
    gift: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>',
    plus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    x:    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>'
  };
  /* Le nom de l'article vient du produit : « Le éthylotest » ou « du éthylotest »
     se liraient comme des fautes. Le genre n'étant pas devinable, on suppose le
     masculin — ce que product.type donne ici. */
  var VOY = /^[aàâeéèêëiïîoôuùûyh]/i;
  var LE  = function (w) { return (VOY.test(w) ? "L'" : 'Le ') + w; };
  var DU  = function (w) { return (VOY.test(w) ? "de l'" : 'du ') + w; };
  var RESTE = function (k, w, ws) {
    return k === 1 ? "Plus qu'un " + w : 'Plus que ' + k + ' ' + ws;
  };

  var pic = function (url, w) {
    return '<span class="so-sw">' +
      (url ? '<img src="' + esc(url) + '" alt="" loading="lazy" width="' + w + '" height="' + w + '">' : '') +
      '</span>';
  };

  /* select() de quietude-pdp.js est privé : son seul point d'entrée public est le
     clic sur une puce ou une vignette. On passe par lui, ce qui garde rail, points
     et vignettes d'accord. `m` = index du média, calculé en Liquid. */
  function showMedia(m) {
    if (m === '' || m === null || m === undefined) return;
    var go = document.querySelector('.mm-gallery [data-dot="' + m + '"]') ||
             document.querySelector('.mm-gallery [data-thumb="' + m + '"]');
    if (go) go.click();
  }

  function boot(root) {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';

    var BUY  = parseInt(root.getAttribute('data-buy'), 10)  || 2;
    var FREE = parseInt(root.getAttribute('data-free'), 10) || 1;
    var SIZE = BUY + FREE;

    /* Le nom de l'article vient du produit, pas du code. Tous les libellés en
       dépendent. */
    var NOUN  = root.getAttribute('data-noun') || 'article';
    var NOUNS = root.getAttribute('data-noun-plural') || (NOUN + 's');

    var COLORIS = [], current = null;
    try { COLORIS   = JSON.parse(root.getAttribute('data-catalog') || '[]'); } catch (e) {}
    try { current = JSON.parse(root.getAttribute('data-current') || 'null'); } catch (e) {}
    if (!current || !COLORIS.length) { root.remove(); return; }

    var form = document.querySelector('form[data-add-form]');
    var cta  = form && form.querySelector('.mm-cta');
    var buy  = form && form.closest('.mm-buy');

    var slots = [current];
    for (var i = 1; i < SIZE; i++) slots.push(null);
    var unbacked = false;
    var openAt = -1;              /* emplacement dont la rangée de pastilles est ouverte */

    /* Le moins cher est offert, et à prix égal le dernier choisi : sinon le badge
       désigne un article et la remise en déduit un autre. Les trois coloris étant
       au même prix, le badge tombe sur le 3e — l'annonce est donc exacte. */
    function freeSet(list) {
      var filled = [];
      list.forEach(function (b, i) { if (b) filled.push({ b: b, i: i }); });
      var sets = Math.floor(filled.length / SIZE);
      if (!sets) return {};
      var out = {};
      filled.slice().sort(function (a, b) { return a.b.p - b.b.p || b.i - a.i; })
            .slice(0, sets * FREE).forEach(function (x) { out[x.i] = true; });
      return out;
    }
    function quote() {
      var free = unbacked ? {} : freeSet(slots);
      var gross = 0, saved = 0, n = 0, names = [];
      slots.forEach(function (b, i) {
        if (!b) return;
        n++; gross += b.p;
        if (free[i]) { saved += b.p; names.push(b.t); }
      });
      return { gross: gross, saved: saved, net: gross - saved, n: n, free: free, names: names };
    }
    function nextEmpty() {
      for (var i = 0; i < slots.length; i++) { if (!slots[i]) return i; }
      return -1;
    }
    function taken() {
      var t = {};
      slots.forEach(function (b) { if (b) t[b.id] = (t[b.id] || 0) + 1; });
      return t;
    }

    root.innerHTML =
      '<div class="so-box">' +
        '<div class="so-head">' +
          '<p class="so-title">' + ICO.gift + ' <span data-t></span></p>' +
          '<p class="so-sub" data-s></p>' +
          '<div class="so-bar"><span class="so-fill" data-fill></span></div>' +
          '<div class="so-steps" data-steps></div>' +
        '</div>' +
        '<div class="so-slots" data-slots></div>' +
        '<div class="ethsw" data-picker hidden></div>' +
        '<div class="so-foot"><span class="so-meta" data-meta></span>' +
          '<span class="so-total" data-total></span></div>' +
      '</div>';

    var elT = root.querySelector('[data-t]'), elS = root.querySelector('[data-s]');
    var elFill = root.querySelector('[data-fill]'), elSteps = root.querySelector('[data-steps]');
    var elSlots = root.querySelector('[data-slots]'), elPick = root.querySelector('[data-picker]');
    var elMeta = root.querySelector('[data-meta]'), elTotal = root.querySelector('[data-total]');
    var ctaLabel = cta ? cta.textContent.trim() : '';
    var note = null;

    elSteps.innerHTML = (function () {
      var out = [];
      for (var i = 0; i < SIZE; i++) {
        out.push('<span class="so-step" data-i="' + i + '">' +
          esc(i < BUY ? (i + 1) + ' ajouté' + (i > 0 ? 's' : '') : 'offert') + '</span>');
      }
      return out.join('');
    })();

    /* À trois coloris, une modale à paliers coûte plus de gestes qu'elle n'en
       épargne : la rangée remplace la nappe de Quietude. */
    function drawPicker() {
      if (openAt < 0) { elPick.hidden = true; elPick.innerHTML = ''; return; }
      var t = taken();
      elPick.hidden = false;
      elPick.innerHTML =
        '<p class="ethsw-h">Coloris ' + esc(DU(NOUN)) + ' ' + (openAt + 1) + '</p>' +
        '<div class="ethsw-row" role="group" aria-label="Choisir un coloris">' +
        COLORIS.map(function (b) {
          var q = t[b.id] || 0;
          return '<button type="button" class="ethsw-dot" data-pick="' + b.id + '"' +
            ' style="--c:' + esc(b.c || '#cfcfcf') + '"' +
            ' aria-label="' + esc(b.t) + (q ? ', ' + q + ' dans votre lot' : '') + '">' +
            (q ? '<span class="ethsw-q">' + q + '</span>' : '') + '</button>';
        }).join('') +
        '</div>' +
        '<p class="ethsw-n" data-pick-name>' + esc(COLORIS[0].t) + '</p>';
    }

    function draw() {
      var q = quote(), done = q.n === SIZE;

      elT.textContent = done
        ? (unbacked ? 'Votre lot de ' + SIZE : 'Votre lot est complet')
        : root.getAttribute('data-label');
      elS.textContent = done
        ? (unbacked ? "L'offre n'est pas active en ce moment."
                    : LE(NOUN) + ' ' + q.names.join(' et ') + ' est offert.')
        : RESTE(SIZE - q.n, NOUN, NOUNS) + ' et le ' + SIZE + 'e est offert.';
      elFill.style.width = (q.n / SIZE * 100) + '%';
      elSteps.querySelectorAll('.so-step').forEach(function (s) {
        s.classList.toggle('on', q.n > parseInt(s.getAttribute('data-i'), 10));
      });

      elSlots.innerHTML = slots.map(function (b, i) {
        var isFree = unbacked ? false : (done ? !!q.free[i] : i === SIZE - 1);
        var cls = 'so-slot' + (isFree ? ' is-free' + (done ? ' unlocked' : '') : '') +
                  (openAt === i ? ' is-open' : '');
        var tag = isFree ? '<span class="so-tag">Offert</span>' : '';
        if (b) {
          return '<div class="' + cls + '" data-filled="1">' + tag +
            '<span class="so-dot">' + pic(b.img, 76) + '</span>' +
            '<span class="so-name">' + esc(b.t) + '</span>' +
            (i ? '<button class="so-x" type="button" data-clear="' + i +
                 '" aria-label="' + esc('Retirer ' + b.t) + '">' + ICO.x + '</button>' : '') +
          '</div>';
        }
        return '<button class="' + cls + '" type="button" data-slot="' + i +
          '" data-filled="0" aria-expanded="' + (openAt === i ? 'true' : 'false') +
          '" aria-label="' + esc('Choisir le coloris ' + DU(NOUN) + ' ' + (i + 1)) + '">' + tag +
          '<span class="so-ico-plus">' + ICO.plus + '</span>' +
          '<span class="so-hint">Ajouter</span></button>';
      }).join('');

      drawPicker();

      elTotal.textContent = money(q.net);
      elMeta.innerHTML = q.saved
        ? '<s class="so-strike">' + money(q.gross) + '</s> ' +
          '<span class="so-plus-save">' + MINUS + money(q.saved) + '</span>'
        : esc(q.n + ' sur ' + SIZE + ' choisis');

      if (cta) {
        cta.textContent = done ? 'Ajouter le lot ' + MINUS + ' ' + money(q.net) : ctaLabel;
        if (!note) {
          note = document.createElement('p');
          note.className = 'so-note';
          cta.parentNode.insertBefore(note, cta.nextSibling);
        }
        note.textContent = unbacked ? ''
          : (done ? 'Vous économisez ' + money(q.saved) + ', déduits dans votre panier.'
                  : (SIZE - q.n === 1 ? "Plus qu'un" : 'Plus que ' + (SIZE - q.n)) +
                    ' et le ' + SIZE + 'e est offert.');
        note.hidden = !note.textContent;
      }
      if (buy) {
        buy.classList.toggle('qt-set-armed', q.n > 1);
        buy.classList.toggle('qt-set-ready', done);
      }
    }

    root.addEventListener('click', function (e) {
      var clr = e.target.closest('[data-clear]');
      if (clr) {
        slots[parseInt(clr.getAttribute('data-clear'), 10)] = null;
        var kept = slots.filter(Boolean);
        slots = kept.concat(new Array(SIZE - kept.length).fill(null));
        openAt = -1;
        return draw();
      }

      var slot = e.target.closest('[data-slot]');
      if (slot) {
        var i = parseInt(slot.getAttribute('data-slot'), 10);
        openAt = (openAt === i) ? -1 : i;       /* un second clic referme */
        return draw();
      }

      var dot = e.target.closest('[data-pick]');
      if (!dot) return;
      var id = dot.getAttribute('data-pick');
      var choix = COLORIS.filter(function (b) { return String(b.id) === id; })[0];
      if (!choix) return;
      var at = nextEmpty();
      if (at < 0) return;
      slots[at] = choix;
      showMedia(choix.m);
      /* On enchaîne : composer un lot ne doit pas demander de viser trois fois
         le même bouton. */
      openAt = nextEmpty();
      draw();
    });

    /* Le rond seul ne se nomme pas : le survol l'écrit sous la rangée. */
    root.addEventListener('pointerover', function (e) {
      var dot = e.target.closest('[data-pick]');
      var out = root.querySelector('[data-pick-name]');
      if (!dot || !out) return;
      var b = COLORIS.filter(function (x) { return String(x.id) === dot.getAttribute('data-pick'); })[0];
      if (b) out.textContent = b.t;
    });

    var CHECKOUT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'checkout';
    function discountApplied(cart) {
      return (cart.total_discount || 0) > 0 ||
        (cart.items || []).some(function (it) { return (it.total_discount || 0) > 0; });
    }

    function addSet(btn) {
      var items = slots.filter(Boolean).map(function (b) { return { id: b.id, quantity: 1 }; });
      if (btn) { btn.disabled = true; btn.textContent = 'Ajout…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || 'Ajout au panier impossible');
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('.mm-count, .cart-count, .hy-count').forEach(function (c) {
            c.textContent = cart.item_count;
          });
          if (typeof window.qtOpenCart === 'function') window.qtOpenCart(cart);
          syncOffer(cart);
        })
        .catch(function (err) { if (btn) btn.textContent = String(err.message).slice(0, 40); })
        .finally(function () {
          setTimeout(function () { if (cta) cta.disabled = false; draw(); }, 1600);
        });
    }

    document.addEventListener('submit', function (e) {
      if (!form || e.target !== form) return;
      if (quote().n !== SIZE) return;
      e.preventDefault();
      e.stopPropagation();
      addSet(cta);
    }, true);

    /* Lot complet au panier sans déduction : la remise est absente, expirée ou
       planifiée. On cesse d'annoncer une économie que le paiement ne fera pas. */
    function syncOffer(cart) {
      if (!cart || cart.item_count < SIZE) return;
      var applied = discountApplied(cart);
      if (applied === !unbacked) return;
      unbacked = !applied;
      root.classList.toggle('so-unbacked', unbacked);
      draw();
      if (unbacked && window.console) {
        console.warn('[ETHYLGO] Lot complet au panier, aucune remise appliquée : la remise ' +
                     'automatique « ' + root.getAttribute('data-label') + ' » est absente, ' +
                     "expirée ou planifiée. Le bloc cesse d'annoncer l'économie.");
      }
    }

    /* ---- la rangée de coloris du bloc d'achat ----
       La section sort des rectangles data-variant, sans couleur ni image. On les
       habille ici, et on ajoute ce que quietude-pdp.js ne fait pas : montrer la
       photo du coloris. */
    function enhancePills() {
      var row = document.querySelector('.mm-panel .mm-vrow');
      if (!row || row.dataset.ethSwatch) return;
      row.dataset.ethSwatch = '1';
      row.classList.add('ethsw-row', 'ethsw-row--pills');
      row.querySelectorAll('[data-variant]').forEach(function (pill) {
        var b = COLORIS.filter(function (x) { return String(x.id) === pill.getAttribute('data-variant'); })[0];
        if (!b) return;
        pill.classList.add('ethsw-dot');
        pill.style.setProperty('--c', b.c || '#cfcfcf');
        pill.setAttribute('aria-label', b.t);
        pill.setAttribute('title', b.t);
        pill.addEventListener('click', function () {
          if (pill.disabled) return;
          showMedia(b.m);
          /* Le 1er emplacement suit le bloc d'achat : c'est le coloris que le
             visiteur vient de désigner comme le sien. */
          slots[0] = b;
          draw();
        });
      });
    }

    draw();
    enhancePills();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-eth-set-offer]').forEach(boot);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();